<!-- 
  Navbar Container: isWorkflowSummaryView
  Hide the entire navbar and header for workflow summary view pages to provide a clean,
  distraction-free reading experience for workflow summary content 
-->
<div class="navbar-container" *ngIf="!isWorkflowSummaryView && !isPrerequisiteView && !isWorkflowExecutionHistoryView">
    <div class="navbar">
        <!-- iterate over navbar menus -->
        <div *ngFor="let menu of menuArray, let i = index" id="navbar-{{i}}" class="cursor">
            <!-- display menu which dont have submenu -->
            <div [ngClass]="componentName.toLowerCase().startsWith(menu.text.toLowerCase()) ? 'nav-element nav-element-selected' : 'nav-element'"
                *ngIf="!menu.children" [routerLink]="[menu.routerLink]">
                <div class="title">{{il8Service.getString(menu.text) }}
                </div>
            </div>

            <!-- displays menu which have submenu -->
            <div *ngIf="menu.children"
                [ngClass]="(componentName.toLowerCase().includes(menu.text.toLowerCase())) ? 'nav-element-with-submenu nav-element-selected' : 'nav-element-with-submenu'">
                <div mat-icon-button aria-label="Example icon-button with a menu" class="nev-element-container"
                    #trigger="matMenuTrigger" [matMenuTriggerFor]="submenu">
                    {{ il8Service.getString(menu.text) }}
                    <div class="drop-icon" *ngIf="trigger.menuOpen">
                        <span class="material-icons">arrow_drop_up</span>
                    </div>
                    <div class="drop-icon" *ngIf="!trigger.menuOpen">
                        <span class="material-icons">arrow_drop_down</span>
                    </div>
                </div>

                <mat-menu #submenu="matMenu">
                    <!-- iterate over submenus -->
                    <button class="nev-element-sunbmenu-option-container" style="min-width: 11rem;" mat-menu-item
                        *ngFor="let submenu of menu.children" [routerLink]="submenu.routerLink">
                        <div class="nav-sunbmenu-element">
                            <div class="title">{{ il8Service.getString(submenu.text)}}</div>
                        </div>
                    </button>
                </mat-menu>
            </div>
        </div>
    </div>

    <!-- display menu selected -->
    <mat-toolbar class="mat_toolbar">
        <div fxFlex="100" class="cardTitle" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="start center">
                <mat-icon [id]="tourId.workflows.wfrun.wfBack.id" *ngIf="router.url.includes('/workflow-run')"
                class="back-icon cursor"   (click)="navigate('/workflows')">chevron_left</mat-icon>
                <span>{{componentName}}</span>
            </div>

            <div fxLayout="row" *ngIf="!router.url.includes('/app-auth-callback')" fxLayoutAlign="start center"
                fxLayoutGap="10px">
                <div [id]="tourId.wfQueueMgr.dropDown.id" fxLayout="row" fxLayoutGap="10px"
                    *ngIf="['/feature-workflow','/queue-mngr','/github-actions'].includes(router.url) || ['/admin'].includes(router.url) || (router.url.includes('/workflow-run')) || ('/dashboard'.includes(router.url)) && guidedTourService.dashboardTab == 'Summary'">
                    <app-auto-complete-dropdown *ngIf="!['/github-actions'].includes(router.url)"
                        [dropDownOptions]="switchDropDownOptions()" [placeholder]="placeholder()"
                        (selectedOptions)="commonService.dropDown($event, ['/admin'].includes(router.url) ? 'pageNm' : 'repoDropdown')"
                        [sltOption]="selectedRepo">
                    </app-auto-complete-dropdown>
                    <app-dropdown *ngIf="!['/admin','/github-actions'].includes(router.url)" [customHight]="'4.6rem'"
                        [selectedOption]="selectedDuration" [style]="durationStyle" [chart]="'duration'"
                        [title]="durationTitle" [options]="durationDropdown" (dropDownUpdate)="updateDropDown($event)">
                    </app-dropdown>

                    <app-dynamic-dropdown *ngIf="['/github-actions'].includes(router.url)" [data]="gitActionsResp"
                        [isRootNode]="true" [isGithubActions]="true" [isSelect]="true"
                        [childFormControl]="dummyFormControl" [feature]="'gitActionsDropdown'"
                        [placeholder]="'Repository'">
                    </app-dynamic-dropdown>
                </div>

                <mat-icon (click)="onClickHelp()" class="cursor" style="font-size: 20px;"
                    *ngIf="(!router.url.includes('/app-auth-callback') && !'/integrated-workflows'.includes(router.url) && !router.url.includes('/github-workflows/execute'))"
                    [matMenuTriggerFor]="helpMenu">help_outline</mat-icon>
            </div>
            <mat-menu #helpMenu="matMenu">
                <button mat-menu-item (click)="guidedTourService.startPageTour(true)">Start tour guide</button>
                <button [matTooltip]="matTooltipHelp" [disabled]="helpButtonLink || router.url.includes('/dependent-checks') || router.url.includes('/github-sync') || router.url.includes('/pr-grouping')" *ngIf="!router.url.includes('/help-page')" mat-menu-item (click)="helpGuide()">{{ il8Service.getString('help')}}
                </button>
            </mat-menu>
        </div>
    </mat-toolbar>
    <mat-progress-bar class="query-progress" mode="query" *ngIf="loaderService?.isLoading | async"></mat-progress-bar>
</div>